import {useState} from "react";
import {bookingAPI} from "../common/api/bookingAPI";
import {API_BOOKING} from "../common/api/apiConstants";
import {useKeycloakFunctions} from "./useKeycloakFunctions";

export const useBookingConfirm = () => {

    const {initialized, authenticated} = useKeycloakFunctions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const postBookingConfirm = (resort_id, apartment_short_code, date_from, date_to, number_of_guests, flexible_booking, wheelchair_accessible, locale, currency, points_extra_purchase, insurance_response_codes, reservation_id, duplicate_booking_accepted = false) => {

        if (initialized && authenticated) {
            setLoading(true);
            setError(null);

            const body = {
                resort_id,
                apartment_short_code,
                date_from,
                date_to,
                number_of_guests: String(number_of_guests),
                flexible_booking,
                wheelchair_accessible: String(wheelchair_accessible),
                locale,
                currency,
                points_extra_purchase,
                insurance_response_codes,
                reservation_id,
                duplicate_booking_accepted
            };

            return bookingAPI.post(API_BOOKING, body)
                .then(res => {
                    setLoading(false);
                    return res;
                })
                .catch(err => {
                    setLoading(false);
                    setError(err?.response);
                    throw err.response;
                });
        }

    };

    return {
        postBookingConfirm,
        loadingBookingConfirm: loading,
        errorBookingConfirm: error
    };
};
